import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-auth',
  standalone: false,
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {

  private readonly _dialogRef = inject(MatDialog);

  public ngOnInit() {
    this._dialogRef.closeAll();
  }

}
